import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-skeleton-table',
    templateUrl: './skeleton-table.component.html',
    styleUrls: ['./skeleton-table.component.scss'],
})
export class SkeletonTableComponent {
    // default values
    @Input() columns = 5
    @Input() rows = 3

    get colArray(): number[] {
        return Array(this.columns).fill(0)
    }
    get rowArray(): number[] {
        return Array(this.rows).fill(0)
    }
}
